import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import styled from "react-emotion";
import queryString from "query-string";
import { V1Form as Form, V1Input as Input } from "em-form";
import Button from "components/Button";
import { Link, navigate } from "@reach/router";

import theme from "components/theme";

import logoIcon from "../../assets/images/logo-icon.png";

class AuthFormLogin extends Component {
  formRef = React.createRef();
  state = { formData: { password: null, username: null } };

  login = async () => {
    const { formRef } = this;
    const { api } = this.props;
    const { formData } = this.state;
    let { username = "admin" } = formData;
    const { password } = formData;

    if (this.isConsoleLogin()) {
      username = "admin";
      this.setState({ formData: { username, password } });
    }

    const modelName = username === "admin" ? "Admin" : "Store";

    const query = queryString.parse(window.location.search);

    if (formRef.current.validate()) {
      await api
        .post("authTokenGenerate", { username, password, modelName, redirect: query.redirect, includeMaster: true })
        .then(({ token, redirectLink }) => {
          api.setToken(token);

          navigate(query.redirect || redirectLink || "/");
        })
        .catch(({ error }) => formRef.current.setFieldError("password", [error.message]));
    }
  };

  isConsoleLogin = () => {
    const query = queryString.parse(window.location.search);

    return query.redirect && query.redirect.match(/^\/console/);
  };

  onDataUpdate = data => {
    const { formRef } = this;
    formRef.current.clearErrors();
    this.setState({ formData: data });
  };

  render() {
    const { login, formRef, isConsoleLogin, onDataUpdate } = this;
    const { className } = this.props;
    const { formData } = this.state;

    let constraints = {
      username: {
        presence: { message: "Bitte gib deinen Benutzernamen an." },
      },
      password: {
        presence: { message: "Bitte gib deinen Passwort an." },
      },
    };

    if (isConsoleLogin()) {
      constraints = {
        password: {
          presence: { message: "Bitte gib deinen Passwort an." },
        },
      };
    }

    return (
      <div className={className}>
        <div className="text-center">
          <div className="small-logo">
            <img src={logoIcon} alt="" title="" />
          </div>
          <div className="hello">Herzlich Willkommen</div>
          <Form
            ref={formRef}
            onDataSubmit={() => login()}
            data={formData}
            onDataUpdate={onDataUpdate}
            constraints={constraints}
          >
            <div className="inputs">
              {!isConsoleLogin() && (
                <Fragment>
                  <div className="profile-label">Benutzername</div>
                  <Input type="text" name="username" className="profile-input" />
                </Fragment>
              )}
              <div className="profile-label">Passwort</div>
              <Input type="password" name="password" className="profile-input" />
            </div>
            <div>
              <Button type="submit" className="transform-none bold-heavy wide submit-button">
                Anmelden
              </Button>
            </div>
          </Form>
          <Link to="/login/forgot" className="password-link">
            Passwort vergessen?
          </Link>
        </div>
      </div>
    );
  }
}

AuthFormLogin = observer(AuthFormLogin);
AuthFormLogin = inject("api")(AuthFormLogin);
AuthFormLogin = styled(AuthFormLogin)`
  .field-error-message {
    display: block;
    color: ${theme.colors.danger};
    padding: 5px;
  }
  .profile-label {
    ${theme.fonts.bold}
    font-size: 18px;
    ${theme.colors.grayDark};
    text-align: left;
    padding: 16px 0px 8px 0px;
  }
  .profile-input {
    height: 36px;
    border-radius: 5px;
    border: solid 1px ${theme.colors.grayOO};
    width: 100%;
    padding: 5px 10px;
  }
  .password-link {
    ${theme.fonts.bold};
    font-size: 12px;
    color: ${theme.colors.grayDark};
  }
  .submit-button {
    margin-bottom: 30px;
  }
  .small-logo {
    width: 44px;
    height: 44px;
    background-color: ${theme.colors.grayF};
    border-radius: 50%;
    margin: 12px auto;
    position: relative;
    img {
      width: 30px;
      height: 30px;
      ${theme.misc.centerhv};
    }
  }
  .hello {
    ${theme.fonts.bold}
    font-size: 18px;
    ${theme.colors.grayDark}
  }
  .inputs {
    margin-top: 20px;
    margin-bottom: 30px;
    display: inline-block;
    position: relative;
    width: 100%;
  }
`;

export default AuthFormLogin;
